import { cn } from "@/lib/utils";
import type {
  CSSProperties,
  ForwardedRef,
  HTMLAttributes,
  ReactNode,
} from "react";
import { forwardRef } from "react";

export interface RadioProps extends HTMLAttributes<HTMLInputElement> {
  checked?: boolean;
  disabled?: boolean;
  id?: string;
  children: ReactNode;
  indeterminate?: boolean;
  style?: CSSProperties;
  checkedIcon?: ReactNode;
  uncheckedIcon?: ReactNode;
  indeterminateIcon?: ReactNode;
  classNames?: {
    checkbox?: string;
    label?: string;
  };
}

export const Radio = forwardRef(
  (
    {
      id = "checkbox-id",
      disabled,
      checked,
      indeterminate,
      children,
      style,
      onChange,
      classNames,
      ...props
    }: RadioProps,
    ref: ForwardedRef<HTMLLabelElement>,
  ) => (
    <div className="flex items-center">
      <div className="relative mr-2 h-5 w-5 text-sm">
        <input
          checked={checked}
          id={id}
          type="radio"
          value=""
          disabled={disabled}
          onChange={onChange}
          className={cn(
            "action-focus grid h-full w-full appearance-none rounded-full border border-current text-current",
            "before:block before:h-full before:w-full before:scale-0 before:rounded-[inherit] before:bg-current",
            "checked:before:scale-75",
            indeterminate && "before:scale-75",
            classNames?.checkbox,
          )}
          {...props}
        />
      </div>

      <label
        ref={ref}
        style={style}
        htmlFor={id}
        className={cn("cursor-pointer text-base", classNames?.label)}
      >
        {children}
      </label>
    </div>
  ),
);
